"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

require("./style/index");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AppVersion = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AppVersion, _React$Component);

  var _super = _createSuper(AppVersion);

  function AppVersion() {
    var _temp, _this;

    (0, _classCallCheck2.default)(this, AppVersion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      version: {}
    }, _temp));
  }

  (0, _createClass2.default)(AppVersion, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res, version;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch('https://cdn.atzuche.com/data/version.json');

              case 2:
                res = _context.sent;
                _context.next = 5;
                return res.json();

              case 5:
                version = _context.sent;
                this.setState({
                  version: version
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state$version$l, _this$state$version$v;

      var memberRuleLink = this.props.isMobile ? '/node/cms/tpl/memberRule' : '/about/vipServiceWeb';
      var policyLink = this.props.isMobile ? '/node/cms/tpl/privacyPolicy' : '/about/privacyPolicy';
      var cn = this.props.isMobile ? 'at-app-version_mobile' : 'at-app-version_pc';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(cn)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "policy item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: policyLink,
        target: "_blank"
      }, "\u9690\u79C1\u534F\u8BAE"), /*#__PURE__*/_react.default.createElement("a", {
        href: memberRuleLink,
        target: "_blank"
      }, "\u7528\u6237\u6743\u9650")), /*#__PURE__*/_react.default.createElement("div", {
        className: "item"
      }, "\u5F00\u53D1\u8005\u540D\u79F0\uFF1A\u4E0A\u6D77\u99A8\u715C\u4FE1\u606F\u79D1\u6280\u6709\u9650\u516C\u53F8"), /*#__PURE__*/_react.default.createElement("div", {
        className: "item"
      }, "\u66F4\u65B0\u65F6\u95F4\uFF1A", (_this$state$version$l = this.state.version.lastUpdateTime) !== null && _this$state$version$l !== void 0 ? _this$state$version$l : '2021.5.20', " \u7248\u672C\uFF1A", (_this$state$version$v = this.state.version.version) !== null && _this$state$version$v !== void 0 ? _this$state$version$v : '6.5.2'));
    }
  }]);
  return AppVersion;
}(_react.default.Component);

exports.default = AppVersion;